import React from 'react'
import {BsTwitter, BsLinkedin, BsGithub} from 'react-icons/bs'
import {SiHashnode, SiFreecodecamp} from "react-icons/si"

const SocialMedia = () => {
  return (
    <div className='app__social'>
      <div>
        <a href='https://twitter.com/Fadahunsiseyi_' target='_blank' rel="noreferrer">
        <BsTwitter/>
        </a>
      </div>
      <div>
        <a href='https://www.linkedin.com/in/fadahunsiseyi'  target='_blank' rel="noreferrer">
        <BsLinkedin/>
        </a>
      </div>
      <div>
        <a href='https://www.freecodecamp.org/news/author/fadahunsi/'  target='_blank' rel="noreferrer">
        <SiFreecodecamp/>
        </a>
      </div>
      <div>
        <a href='http://fadahunsi.hashnode.dev'  target='_blank' rel="noreferrer">
        <SiHashnode/>
        </a>
      </div>
      <div>
        <a href='https://github.com/Fadahunsiseyi'  target='_blank' rel="noreferrer">
        <BsGithub/>
        </a>
      </div>
    </div>
  )
}

export default SocialMedia
